// @ts-nocheck
import { SplitOrderCartLineNotesModel } from "@store/Framework/Types/ApiModels";
import {
    UpdateSplitOrderCartLineNotesAPIParameters,
    updateSplitOrderCartLineNotesWithResult as updateSplitOrderCartLineLineApi,
} from "@store/Framework/Services/SplitOrderCartLineService";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@toolkit/Modules/client-framework/HandlerCreator";

interface UpdateSplitOrderCartLineNotesParameter {
    onSuccess?: () => void;
    splitOrderCartLineNotes: SplitOrderCartLineNotesModel;
}

type HandlerType = ApiHandlerDiscreteParameter<
    UpdateSplitOrderCartLineNotesParameter,
    UpdateSplitOrderCartLineNotesAPIParameters
>;

export const DispatchBeginUpdateCartLine: HandlerType = props => {
    props.dispatch({
        type: "Greif/Pages/ReviewAndSubmit/BeginUpdateSplitOrderCartLine",
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter, ...props.parameter.splitOrderCartLineNotes };
};

export const UpdateCartLineNotes: HandlerType = async props => {
    try {
        await updateSplitOrderCartLineLineApi(props.apiParameter);
    } catch (error) {
        if ("status" in error && (error.status === 400 || error.status === 404)) {
            props.dispatch({
                type: "Greif/Pages/ReviewAndSubmit/FailedToUpdateSplitOrderCartLine",
            });
            return false;
        }

        throw error;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const DispatchCompleteUpdateCartLine: HandlerType = props => {
    props.dispatch({
        type: "Greif/Pages/ReviewAndSubmit/CompleteUpdateSplitOrderCartLine",
    });
};

export const chain = [
    DispatchBeginUpdateCartLine,
    PopulateApiParameter,
    UpdateCartLineNotes,
    DispatchCompleteUpdateCartLine,
    ExecuteOnSuccessCallback,
];

const updateSplitOrderCartLineNotes = createHandlerChainRunner(chain, "UpdateSplitOrderCartLine");
export default updateSplitOrderCartLineNotes;
